// extracted by mini-css-extract-plugin
export var select = "useCalendar-module--select--36Us-";